import styled from 'styled-components';
import { units } from '@m/alchemy-ui/theme';
import { DialogBody } from '@m/alchemy-ui/DialogBody';

export const PublishSection = styled.div`
  margin-top: ${units(3)};
`;

export const StyledField = styled.div`
  margin-bottom: ${units(2.5)};
  [class*='FieldStatus'] {
    font-size: 12px;
  }
`;

export const LabelWithTooltip = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-weight: bold;
`;

export const FileUploadInstructions = styled.span`
  color: #6b7587;
  font-size: 12px;
`;

export const UploadFieldGap = styled.div`
  margin-bottom: 16px;
`;

export const DialogContent = styled.div`
  min-height: ${units(40)};
`;

export const TabContainer = styled.div`
  margin-bottom: ${units(2)};
`;

export const ToastWrapper = styled.div`
  width: 100%;
  position: relative;
`;

export const ToastBox = styled.div`
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
`;

export const StyledDialogBody = styled(DialogBody)`
  overflow-x: hidden;
  margin-bottom: 0;
`;

export const StyledButtonRow = styled.div`
  [class*='ButtonRow__StyledButtonRow'] {
    margin-bottom: 0;
    margin-top: 0;
    padding-bottom: 0;
  }
`;
